<template>
  <div class="product-info-wrapper">
    <div class="banner">
      <div class="cover cover-aiot">
        <div class="cover-text">
          <h4>AIOT平台</h4>
          <p class="info">AloT平台是一款高度智能化、模块化的基础支撑平台。它以城市微场景为场域，以物联网、AI技术为抓手，对场景海量终端设备及数据进行全生命周期管理，强化物联感知对顶层应用场景的支撑能力。一方面，平台支持对物联设备进行智慧化管理、预测性运维以及动态化监测；另一方面，平台具备多模态AI能力，可进行多维数据感知、全局态势洞察、实时决策分析、持续学习演进，辅助在复杂场景下做出最优决策。</p>
        </div>
      </div>
    </div>
    <!-- 产品功能 -->
    <div class="product-function">
      <div class="common-title">
        <div class="common-title-content">
          产品功能
        </div>
      </div>
      <div class="product-function-list">
        <div class="item" v-for="(item, index) in funcList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="product-advantage product-advantage-blue bg2F61AE">
      <div class="common-title">
        <div class="common-title-content">
          产品优势
        </div>
      </div>
      <div class="content content-blue">
        <div class="circle">
          <div class="badge">
            <img src="@/assets/images/productInfo/aiot/badge.png" />
          </div>
          <div class="feature feature-one">
            <div class="text">设备快速接入</div>
          </div>
          <div class="feature feature-two">
            <div class="text">设备智能管理</div>
          </div>
          <div class="feature feature-three">
            <div class="text">接口规范统一</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="product-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="product-scene-list">
        <div class="item" v-for="(item, index) in sceneList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text" v-html="item.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "zhsqglpt",
  data() {
//     产品功能：产品管理   设备管理   设备运维    规则引擎   设备地图
// 产品优势：设备快速接入  设备智能管理   接口规范统一  
// 应用场景：入侵告警  高抛监测  浓烟警报  防盗侦测 
    return {
      funcList: [
        {
          imgUrl: require("@/assets/images/productInfo/aiot/ico_cpgl.png"),
          text: "产品管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/aiot/ico_sbgl.png"),
          text: "设备管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/aiot/ico_sbyw.png"),
          text: "设备运维"
        },
        {
          imgUrl: require("@/assets/images/productInfo/aiot/ico_gzyq.png"),
          text: "规则引擎"
        },
        {
          imgUrl: require("@/assets/images/productInfo/aiot/ico_sbdt.png"),
          text: "设备地图"
        }
      ],
      sceneList: [
        {
          imgUrl: require("@/assets/images/productInfo/aiot/rqjg.png"),
          text: "入侵告警"
        },
        {
          imgUrl: require("@/assets/images/productInfo/aiot/gkpw.png"),
          text: "高抛监测"
        },
        {
          imgUrl: require("@/assets/images/productInfo/aiot/nyjg.png"),
          text: "浓烟警报"
        },
        {
          imgUrl: require("@/assets/images/productInfo/aiot/fdzc.png"),
          text: "防盗侦测"
        }
      ]
    };
  }
};
</script>
